(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["sortBy"] = factory();
	else
		root["sortBy"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition